import React from "react";
import styled from "styled-components";
import product1 from "../images/product1.webp";
import product2 from '../images/product2.webp';
import product3 from '../images/product3.webp';
import product4 from '../images/product4.webp';
import product5 from '../images/product5.webp';
import product6 from '../images/product6.webp';


const About = () => {
  return (
    <>
      {/* ABOUT SECTION */}
      <AboutSection>
        <AboutOverlay>
          <AboutContainer>
            <Title>About the Brand</Title>

            <Paragraph>
              <strong>Gift to Inspire</strong> is a spiritually enriching
              marketplace designed to empower and uplift Christian (caregiver)
              artists while offering unique products and gifting solutions to
              our customers.
            </Paragraph>

            <SubTitle>Who We Serve</SubTitle>

            <Paragraph>
              Gift to Inspire serves Christian men and women aged 15–65 seeking
              unique products that provide inspirational value, and are
              distinctive Christian gifting solutions. Our platform also
              empowers caregiver artists to find joy and purpose by sharing
              their work with a like-minded community, and earning an income
              through the Gift to Inspire marketplace.
            </Paragraph>
          </AboutContainer>
        </AboutOverlay>
      </AboutSection>

      {/* SCROLLING GALLERY SECTION */}
      <ScrollingGallery>
        <GalleryTitle>Our Featured Works</GalleryTitle>

        <ScrollContainer>
          <ScrollContent>
            {/* 12 images (6 original + 6 duplicates for seamless infinite loop) */}
            <img src={product1} alt="" />
            <img src={product2} alt="" />
            <img src={product3} alt="" />
            <img src={product4} alt="" />
            <img src={product5} alt="" />
            <img src={product6} alt="" />

            {/* DUPLICATES */}
            <img src={product1} alt="" />
            <img src={product2} alt="" />
            <img src={product3} alt="" />
            <img src={product4} alt="" />
            <img src={product5} alt="" />
            <img src={product6} alt="" />
          </ScrollContent>
        </ScrollContainer>
      </ScrollingGallery>
    </>
  );
};

export default About;

/* --------------------------
      STYLED COMPONENTS
--------------------------- */

/* ABOUT SECTION */
const AboutSection = styled.section`
  background-color: #f9f9f9;
  padding: 60px 20px;
  text-align: center;
`;

const AboutOverlay = styled.div``;

const AboutContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  color: #333;
`;

const SubTitle = styled.h3`
  font-size: 1.5rem;
  margin-top: 30px;
  color: #444;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  color: #555;
  line-height: 1.7;
  margin-bottom: 15px;
`;

/* SCROLLING GALLERY */
const ScrollingGallery = styled.section`
  background: linear-gradient(135deg, #e0f7fa, #fce4ec);
  text-align: center;
  padding: 60px 0;
  overflow: hidden;
`;

const GalleryTitle = styled.h2`
  font-size: 2rem;
  color: #333;
  margin-bottom: 30px;
`;

const ScrollContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const ScrollContent = styled.div`
  display: flex;
  width: calc(300px * 12);
  animation: scrollImages 25s linear infinite;

  img {
    width: 300px;
    height: 200px;
    margin-right: 10px;
    object-fit: cover;
    flex-shrink: 0;
    border-radius: 0;
  }

  @keyframes scrollImages {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }

  @media (max-width: 768px) {
    width: calc(200px * 12);
    animation: scrollImages 20s linear infinite;

    img {
      width: 200px;
      height: 130px;
    }
  }
`;
